import React from "react";
import {
  parseRewardNumbers,
  formatRewardsList,
  getRegionFromChannel,
} from "../../../../helpers/classicRewards";

export const TableRow = (props) => {
  const {
    ClassicResult,
    amount,
    ClassicLotteryChannel,
    ClassicLotteryStorage,
    status,
    rewardAmount,
    rewardNumbers,
  } = props;

  const getWinningStatus = () => {
    switch (status) {
      case 4:
        return "Trúng thưởng";
      case 5:
        return "Không trúng";
      default:
        return "Chưa tính giải";
    }
  };

  const getWinningStatusClass = () => {
    switch (status) {
      case 4:
        return "text-success fw-bold";
      case 5:
        return "text-secondary";
      default:
        return "text-muted";
    }
  };

  // Parse và format thông tin giải trúng
  const region = getRegionFromChannel(ClassicLotteryChannel);
  const rewards = parseRewardNumbers(rewardNumbers, region);
  const rewardsDisplay = formatRewardsList(rewards);

  return (
    <tr>
      <td className="text-center">
        {ClassicLotteryStorage?.images ? (
          <div
            className="rounded overflow-hidden d-inline-block"
            style={{ width: 48, height: 48, cursor: "pointer" }}
            onClick={() => {
              if (props.onPreviewImage) {
                props.onPreviewImage(`Ảnh vé`, ClassicLotteryStorage.images);
              }
            }}
          >
            <img
              src={ClassicLotteryStorage.images}
              alt="Ticket"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => {
                e.target.parentElement.style.display = "none";
              }}
            />
          </div>
        ) : (
          <span className="text-muted small">-</span>
        )}
      </td>
      <td>{ClassicResult?.resultDate || ""}</td>
      <td className="align-items-center text-center">
        <div className="d-flex align-items-center justify-content-center gap-2">
          {ClassicLotteryChannel?.logo && (
            <img
              src={ClassicLotteryChannel.logo}
              alt={ClassicLotteryChannel.name}
              className="rounded-circle border border-gray-200"
              style={{ width: "24px", height: "24px", objectFit: "cover" }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          )}
          <span>{ClassicLotteryChannel?.name || ""}</span>
        </div>
      </td>
      <td className="align-items-center text-center">
        {(ClassicLotteryStorage?.numbers || "").split("").join(" ")}
      </td>
      <td
        className={`align-items-center text-center ${getWinningStatusClass()}`}
      >
        {getWinningStatus()}
      </td>
      <td className="align-items-center text-center">
        {status === 4 ? rewardsDisplay : "-"}
      </td>
      <td className="align-items-right text-center">
        {new Intl.NumberFormat("vn-VI", {}).format(amount) || ""}
      </td>
      <td className="align-items-right text-center">
        {new Intl.NumberFormat("vn-VI", {}).format(rewardAmount) || ""}
      </td>
    </tr>
  );
};
